<template>
  <div>
    <el-dialog
      width="1200px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <template slot="title">
        <span class="f-s-16">
          <span>选择采购申请明细</span>
          <span class="c-red">(已选{{ selfList.length }})</span>
        </span>
      </template>
      <div class="page-main">
        <div class="flex flex-y-center m-b-10">
          <span>采购申请单号:</span>
          <el-input
            v-model="filterData.shen_gou_code"
            size="mini"
            class="m-l-5"
            style="width: 140px"
            clearable
            @keyup.enter.native="searchListData"
          />
          <span class="m-l-10">供应商:</span>
          <el-input
            v-model="filterData.supplier_name"
            size="mini"
            class="m-l-5"
            style="width: 160px"
            clearable
            @keyup.enter.native="searchListData"
          />
          <span class="m-l-10">物料名称:</span>
          <el-input
            v-model="filterData.name"
            size="mini"
            class="m-l-5"
            style="width: 160px"
            clearable
            @keyup.enter.native="searchListData"
          />
          <el-button class="m-l-10" size="mini" type="primary" @click="searchListData">查询</el-button>
          <span class="c-gray m-l-10">说明：仅显示已审核、且仍有可转数量的采购申请明细</span>
        </div>
        <vxe-grid
          ref="refTable"
          v-bind="tableOptions"
          :height="this.$util.getViewHeight() - 330"
          @keydown="tableKeydown"
          @checkbox-change="tableCheckboxChange"
          @checkbox-all="tableCheckboxChange"
        >
          <template #default_shen_gou_code="{ row }">
            <span>{{ row.shen_gou_code }}</span>
            <el-link type="primary" @click="itemCheckAll(row)"> 全选当前单号 </el-link>
          </template>
          <template #default_goods_price="{ row }">
            {{ row.goods_price }}
          </template>
          <template #default_un_ordered_counts="{ row }">
            <span class="c-orange">{{ row.un_ordered_counts }}</span>
          </template>
          <template #pager>
            <div></div>
            <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      // 已勾选（跨页保留）
      selfList: [],
      filterData: {
        shen_gou_code: '',
        supplier_name: '',
        name: ''
      },
      tableOptions: {
        loading: true,
        size: 'mini',
        border: true,
        checkboxConfig: {
          trigger: 'row',
          reserve: true
        },
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          { fixed: 'left', type: 'checkbox', width: 40 },
          { fixed: 'left', title: '序号', type: 'seq', width: 40 },
          {
            field: 'shen_gou_code',
            title: '采购申请单号',
            width: 190,
            slots: { default: 'default_shen_gou_code' }
          },
          { field: 'shen_gou_date_str', title: '申请日期', width: 100 },
          { field: 'supplier_name', title: '供应商', width: 140 },
          { field: 'bill_code', title: '销售单号', width: 120 },
          { field: 'name', title: '物料名称', width: 140 },
          { field: 'spec', title: '规格(mm)', width: 120 },
          { field: 'unit', title: '单位', width: 60 },
          { field: 'shen_gou_counts', title: '需求数量', width: 80 },
          { field: 'ordered_counts', title: '已下单数量', width: 90 },
          {
            field: 'un_ordered_counts',
            title: '可转数量',
            width: 80,
            slots: { default: 'default_un_ordered_counts' }
          },
          { field: 'goods_price', title: '单价(元)', width: 80 },
          { field: 'remark', title: '备注', minWidth: 120 }
        ],
        data: []
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getListData()
  },
  methods: {
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    getListData() {
      this.tableOptions.loading = true
      let params = {
        currentPage: this.tableOptions.pagerConfig.currentPage,
        pageSize: this.tableOptions.pagerConfig.pageSize,
        filterData: this.filterData
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/caiGouDingDan/listShenGou',
        data: params
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = this.$util.deepCopy(res.data.page.list) || []
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
            // 回显跨页选中
            this.tableOptions.data.forEach((itemSt) => {
              let isChecked = this.selfList.some((itemNd) => itemNd.source_item_id === itemSt.source_item_id)
              if (isChecked) {
                this.$nextTick(() => {
                  this.$refs.refTable.setCheckboxRow([itemSt], true)
                })
              }
            })
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    tableCheckboxChange(params) {
      // 当前页未选中的旧选择保留，当前页选中项覆盖
      let resultDiff = this.selfList.filter((itemSt) => {
        return this.tableOptions.data.every((itemNd) => itemSt.source_item_id !== itemNd.source_item_id)
      })
      let resultCheck = [...params.records]
      this.selfList = [...resultDiff, ...resultCheck]
    },
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        params.$event.preventDefault()
        let row = this.$refs.refTable.getCurrentRecord()
        if (!row) return
        let isChecked = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isChecked)
      }
    },
    itemCheckAll(row) {
      let rows = this.tableOptions.data.filter((item) => item.shen_gou_code === row.shen_gou_code)
      setTimeout(() => {
        this.$refs.refTable.setCheckboxRow(rows, true)
      })
    },
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    popupConfirm() {
      if (!this.selfList.length) {
        this.$message.warning('请先选择采购申请明细')
        return
      }
      // 供应商一致性（一张采购订单只对应一个供应商）
      let suppliers = [...new Set(this.selfList.map((item) => (item.supplier_name || '').trim()))]
      if (suppliers.length > 1) {
        this.$message.warning('所选明细的供应商不一致，请按供应商分批生成采购订单')
        return
      }
      this.$emit('success', this.selfList)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped></style>
